import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '57a2862d-8801-4546-b302-ed41663ea4e1',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '76909d12-944f-4876-9543-fb316c40b1fc',
      type: 'Sprite',
      name: 'myFarmButton',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'my_farm_icon_grey',
      parent: '57a2862d-8801-4546-b302-ed41663ea4e1',
      data: ''
    },
    {
      id: 'ef562f23-3892-4acb-93db-3f8767f5ad82',
      type: 'Sprite',
      name: 'notification',
      nameSpace: '',
      className: '',
      x: 61,
      y: -41,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'notification',
      parent: '76909d12-944f-4876-9543-fb316c40b1fc',
      data: ''
    },
    {
      id: '68abe1aa-4fb6-41eb-82f5-bab25c3e01f5',
      type: 'Text',
      name: 'titleText',
      nameSpace: '',
      className: '',
      x: 2,
      y: 48,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level xx',
      localize: false,
      maxWidth: 75,
      maxHeight: 24,
      maxFontSize: 26,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#892e2e',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '76909d12-944f-4876-9543-fb316c40b1fc',
      data: ''
    },
    {
      id: 'bc5a5312-6116-4bb3-a45f-874b1b3c132f',
      type: 'Sprite',
      name: 'lock',
      nameSpace: '',
      className: '',
      x: -45,
      y: 49,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'my_farm_lock',
      parent: '76909d12-944f-4876-9543-fb316c40b1fc',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class FarmButtonLayout {
  static raw = raw;
  root: PIXI.Container
  myFarmButton: PIXI.Sprite
  notification: PIXI.Sprite
  titleText: PIXI.Text
  lock: PIXI.Sprite

  constructor() {
    populate(this, raw);
  }
}
